<div mat-dialog-title class="dialog-header">
    <div>
        <h4 class="modal-title">Melding {{ chat.id ? 'aanpassen' : 'aanmaken' }}</h4>
    </div>
    <button aria-label="Close" class="close-button" mat-dialog-close="" tabindex="-1">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

@if (form) {
    <div mat-dialog-content [formGroup]="form" class="modal-body">
        <form [formGroup]="form">
            @if (projects && !chat.id) {
                <mat-form-field class="w-100">
                    <mat-placeholder>Kies een project</mat-placeholder>
                    <mat-select [formControl]="fc.customer_project_id">
                        @for (project of projects; track project) {
                            <mat-option [value]="project.id">
                                {{ project.name }}
                            </mat-option>
                        }
                    </mat-select>
                    <mat-error [control]="fc.customer_project_id"></mat-error>
                </mat-form-field>
            }
            @if (chat.id) {
                <mat-form-field class="w-100">
                    <mat-placeholder>Melding naam</mat-placeholder>
                    <input [formControl]="fc.name" matInput placeholder="Naam van de melding" type="text" />
                    <mat-error [control]="fc.name"></mat-error>
                </mat-form-field>
            }
            <mat-form-field class="w-100">
                <mat-placeholder>Soort melding</mat-placeholder>
                <mat-select [formControl]="fc.type">
                    @for (type of types; track type) {
                        <mat-option [value]="type">
                            {{ type }}
                        </mat-option>
                    }
                </mat-select>
                <mat-error [control]="fc.type"></mat-error>
            </mat-form-field>
            @if (fc.type?.value && !chat.id) {
                <mat-form-field class="w-100 mb-2">
                    <textarea
                        [formControl]="fc.firstMessage"
                        cdkAutosizeMinRows="4"
                        cdkTextareaAutosize
                        matInput
                        name="comments"
                        placeholder="Omschrijf uw {{ fc?.type?.value }}"></textarea>
                    <mat-error [control]="fc.firstMessage"></mat-error>
                </mat-form-field>
                @if (isNativePlatform) {
                    <div
                        (click)="camera($event)"
                        [style.background-image]="fc.image?.value | safeBgUrl"
                        class="image"
                        matRipple>
                        @if (!fc.image?.value) {
                            <i class="fas fa-image fa-6x"></i><br />
                            <p>Voeg aan afbeelding toe aan uw melding</p>
                        }
                    </div>
                } @else {
                    <div
                        (click)="uploadInput.click()"
                        [style.background-image]="fc.image?.value | safeBgUrl"
                        class="image"
                        matRipple>
                        <input #uploadInput (change)="uploadFile($event)" [multiple]="true" hidden type="file" />
                        @if (!fc.image?.value) {
                            <i class="fas fa-image fa-6x"></i>
                            <p>Voeg aan afbeelding toe aan uw melding</p>
                            <p>
                                <mat-error
                                    [control]="fc.image"
                                    customMessage="Bij een {{ fc.type.value }} is een afbeelding verplicht"></mat-error>
                            </p>
                        }
                    </div>
                }
            }
        </form>
        @if (chat?.id) {
            <div>
                @for (user of chat?.chat_users; track user) {
                    <div>
                        <div><b>Naam: </b>{{ user.user?.name }} {{ user.user?.lastname }}</div>
                        <div><b>Email: </b>{{ user.user?.email }}</div>
                        <div><b>Telefoon: </b>{{ user.user?.phone }}</div>
                        <div>
                            <b>Adres: </b><br />
                            {{ user.user?.street }} {{ user.user?.housenumber }}<br />
                            {{ user.user?.zipcode }} {{ user.user?.place }}
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}
<div mat-dialog-actions class="modal-footer">
    <button (click)="startChat()" color="primary" mat-flat-button>
        Melding {{ chat.id ? 'aanpassen' : 'aanmaken' }}
    </button>
</div>
